import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiPanel } from '@elastic/eui';
import React, { useState } from 'react';
import ModalApp from '../../../components/Modal';
import ListaSociedadesContainer from '../SelectorSociedadesExpatriados';

interface DataConfiguracion{
    isOpen:boolean;
    sociedades: undefined | any[];
}

export const ConfiguracionRolExpatriaciones = (props:any)=>{

    const {disabled, user, rol, handleSave} = props;

    const [data, setData] = useState<DataConfiguracion>({isOpen:false,sociedades:undefined});
    // const [isOpen, setIsOpen] = useState<boolean>(false);
    // const [sociedades,setSociedades] = useState<any>(undefined);

    const onSave = (sociedades:any) =>{
        setData({isOpen:false,sociedades:sociedades})
        if(sociedades!==undefined)
        {
        const dataSave = sociedades.map((s:any) => s.idSociedad).join(';')
        handleSave({rol:rol.value, sociedades:dataSave})
        }
    }



    const contentModal = () =>(
        <EuiFlexGroup gutterSize='none' style={{height:'100%'}}>
            <EuiFlexItem style={{height:'100%'}}>
            <EuiPanel style={{height:'100%',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                <ListaSociedadesContainer user={user} handleOnSave={onSave} actions sociedadesUsuario={data.sociedades} rol={rol.value}/>
            </EuiPanel>
            </EuiFlexItem>
        </EuiFlexGroup>
    )

    return (
        <>
        <EuiButtonIcon disabled={disabled} iconType='gear' iconSize='m' onClick={()=>{setData({...data,...{isOpen:!data.isOpen}})}}/>
        <ModalApp className='modalApp large' onClose={()=>setData({...data,...{isOpen:false}})} isOpen={data.isOpen} title={`Configuración ${rol.label}`} content={contentModal()}/>
        </>
    )
}